<template>
    <div class="residential">
        <div v-if="!isVerified">
        <div v-if="verifData.data.hasBoth">
        <p class="font-weight-bold" v-html="langText('easyOnboarding.mfa.description.hasboth', true)" />
        <p class="font-weight-bold mb-2" v-text="langText('easyOnboarding.mfa.radio.msisdn.hasboth', true)" />
        <div class="card d-flex flex-nowrap otp-choice" @click.prevent="changeChoice('msisdn')" :class="{ 'card-shadow': choices.mainChoice == 'msisdn' }">
        <div class="flex-shrink mt-2">
            <div class="pl-2 pr-3">
                <input type="radio" style="pointer-events: none;" class="radio-magenta" name="radio-customer" value='msisdn' v-model="choices.mainChoice" :disabled="choices.codeSent && choices.mainChoice === 'email'">
                <label class="custom-radio"></label>
            </div>
        </div>
        <div class="flex-grow cursor-pointer"><strong v-text="verifData.data.mobilePhone" /></div>
        </div>
        <p class="font-weight-bold mb-0 mt-4" v-text="langText('easyOnboarding.mfa.radio.email.hasboth', true)" />
        <div class="card d-flex flex-nowrap otp-choice mt-1" @click.prevent="changeChoice('email')" :class="{ 'card-shadow': choices.mainChoice == 'email' }">
            <div class="flex-shrink mt-2">
                <div class="pl-2 pr-3">
                    <input type="radio" style="pointer-events: none;" class="radio-magenta" name="radio-customer" value='email' v-model="choices.mainChoice" :disabled="choices.codeSent && choices.mainChoice === 'msisdn'">
                    <label class="custom-radio"></label>
                </div>
            </div>
            <div class="flex-grow cursor-pointer"><strong v-text="verifData.data.email" /></div> 
        </div>
        </div>
        <div v-if="verifData.data.hasBoth === false">
            <div v-if="noBothHasChannel">
                <p class="font-weight-bold" v-html="langText('easyOnboarding.mfa.description.missing', true)" />

                <div v-if="(verifData.data.channels.msisdn).length > 0" class="mb-5">
                    <p class="font-weight-bold" v-text="langText('easyOnboarding.mfa.subtitle.msisdn.missing', true)" />
                    <div v-for="sMsisdn in verifData.data.channels.msisdn" :key="sMsisdn.id" @click.prevent="changeChoiceValue(sMsisdn.id)" class="card d-flex flex-nowrap otp-choice mt-3" :class="{ 'card-shadow': choices.notBothValue.id == sMsisdn.id }">
                        <div class="flex-shrink mt-2">
                            <div class="pl-2 pr-3">
                                <input type="radio" style="pointer-events: none;" class="radio-magenta" name="radio-customer" :value="sMsisdn.id" v-model="choices.notBothValue.id" :disabled="choices.codeSent && choices.notBothValue.id !== sMsisdn.id">
                                <label class="custom-radio"></label>
                            </div>
                        </div>
                        <div class="flex-grow cursor-pointer"><strong v-text="sMsisdn.value" /></div> 
                    </div>                

                </div>
                <div v-if="(verifData.data.channels.email).length > 0" class="mb-4">

                    <p class="font-weight-bold" v-text="langText('easyOnboarding.mfa.subtitle.email.missing', true)" />
                    <div v-for="sEmail in verifData.data.channels.email" :key="sEmail.id" @click.prevent="changeChoiceValue(sEmail.id)" class="card d-flex flex-nowrap otp-choice mt-3" :class="{ 'card-shadow': choices.notBothValue.id == sEmail.id }">
                        <div class="flex-shrink mt-2">
                            <div class="pl-2 pr-3">
                                <input type="radio" style="pointer-events: none;" class="radio-magenta" name="radio-customer" :value="sEmail.id" v-model="choices.notBothValue.id" :disabled="choices.codeSent && choices.notBothValue.id !== sEmail.id">
                                <label class="custom-radio"></label>
                            </div>
                        </div>
                        <div class="flex-grow cursor-pointer"><strong v-text="sEmail.value" /></div> 
                    </div>                

                </div>
            </div>
            <div v-else>
                <b-alert variant="warning" show class="d-flex flex-wrap-0 align-items-center justify-content-start pt-3 pb-2 mb-5">
                <div class="flex-grow-0 pl-0 pr-4">
                    <b-icon icon="exclamation-circle" variant="info" class="left-alert-icon" />
                </div>
                <div class="flex-grow-1 mb-1"><span v-html="langText('easyOnboarding.mfa.description.allmising', true)" />
                <span><br/><a class="cursor-pointer" @click="states.mainPage=false" v-text="langText('easyOnboarding.mfa.button.allmising', true)" /></span></div>
                </b-alert>
            </div>
        </div>
        <div v-show="!choices.codeSent">
            <div v-if="verifData.data.hasBoth || (verifData.data.hasBoth === false && noBothHasChannel)">
                <p class="mt-4" v-if="!choices.mainChoice" v-html="langText('easyOnboarding.mfa.mising.text', true)" />
                <div v-else class="mt-4 mb-5 alert alert-info d-flex flex-nowrap align-items-center pt-3 verif-wrapper">
                    <div><b-icon :icon="choices.icon" scale="1.1" class="mr-4" variant="info" /></div>
                    <div><p class="my-2" v-html="targetInfoText" /></div>
                </div>
            </div>                
        </div>
        <div class="verif-wrapper" v-if="choices.mainChoice">

        <div class="input-wrapper position-relative my-4" v-if="choices.codeSent">
        <input
            type="text"
            class="input_text empty mb-1"
            required
            :class="{ error: choices.error }"
            v-model="choices.otpCode"
            id="otpCode"
            ref="otpCode"
            @keyup.enter="verifOtp"
        />
        <label class="placeholder" for="otpCode">{{ langText('easyOnboarding.mfa.otpConfirmText', true) }}{{ targetLabelText }}</label>
            <div class="error_message text-left small text-muted"
            :class="{ 'd-block': choices.error }" v-text="choices.errorText">
            </div>
        </div>

        <b-button variant="secondary" v-if="!choices.codeSent" block class="otp" @click="sendOtp">{{ langText('easyOnboarding.mfa.otpSendButton', true) }}</b-button>
        <div v-else class="mt-5">
            <b-button variant="secondary" block class="otp" @click="verifOtp">{{ langText('easyOnboarding.mfa.otpConfirmButton', true) }}</b-button>
            <b-button variant="link" class="btn-link-otp" block @click="choices.codeSent = false; choices.error = false;">{{ langText('easyOnboarding.mfa.otpResend', true) }}</b-button>
        </div>
    </div>
    </div>
    <ResidSubmit v-if="isVerified" :states="states" :submit-data="submitData" />
    </div>
</template>

<script>
import ResidSubmit from './ResidSubmit'
import langTextMixin from '@/components/common/mixin'
export default {
  name: 'ResidActions',
  mixins: [ langTextMixin ],  
  props: ['states', 'verifData'],
  components: { ResidSubmit },
    data() {
        return {
            choices: { mainChoice: null, notBothValue: { channel: null, id: null, value: null }, icon: 'envelope-fill', otpCode: '', codeSent: false, error: false, errorText: 'Zadaný kód je neplatný' },
            isVerified: false,
            submitData: {}
        }
    },  
    created: function() {
        this.isVerified = false;
        var that = this
        window.history.pushState(null, '')
        window.onpopstate = function() {
        window.history.replaceState(null, '')
            that.states.mainPage = false
        }    
    },
    methods: {
        sendOtp() {
            var that = this;
            this.choices.otpCode = ''; 
            this.choices.error = false;
            this.choices.errorText = this.langText('easyOnboarding.mfa.otpError', true);
            that.$store.commit('setSpinnerState', true);
            this.$http.post(that.$store.state.validateCustSrc + "/otp", { customerCode: that.verifData.data.customerCode, token: that.verifData.data.token, otpType: that.choices.mainChoice, otpTarget: that.choices.notBothValue })     
            .then(function(resp){
                that.choices.codeSent = true;
                that.$nextTick(function() {
                    that.$refs['otpCode'].focus();
                })
                if (resp.data.otp && location.hostname !== 'www.telekom.sk') {
                    that.choices.otpCode = resp.data.otp;                     
                }
            }).catch(function(e){
                that.choices.codeSent = true;
                that.$nextTick(function() {
                    that.choices.error = true;
                    that.choices.errorText = e.response?.status === 403 ? 'Overenie osobných údajov exspirovalo' : 'Požiadavka na odoslanie kódu zlyhala';
                })
            }).finally(function() {
                that.$store.commit('setSpinnerState', false);
            })
        },
        verifOtp() {
            var that = this;
            this.choices.error = false;
            if (!_.isEmpty(this.choices.otpCode)) {
                that.$store.commit('setSpinnerState', true);
                this.$http.put(that.$store.state.validateCustSrc + "/otp", { customerCode: that.verifData.data.customerCode, token: that.verifData.data.token, otpType: that.choices.mainChoice, otpCode: (String(that.choices.otpCode)).replace(/ /g, '')                 
                }).then(function(resp){
                    that.isVerified = true;
                    that.submitData = resp.data;
                }).catch(function(err){
                    that.choices.error = true;
                }).finally(function(){
                    that.$store.commit('setSpinnerState', false);
                    setTimeout(() => {
                        window.parent.scrollBy({
                        top: 120 - window.parent.scrollY,
                        left: 0,
                        behavior: "smooth"
                        })
                    }, 350);                    
                })
            } else {
                that.choices.error = true;
            }
        },
        changeChoice(tc) {
            if (!this.choices.codeSent) {
                this.choices.mainChoice = tc;
                if (this.verifData.data.hasBoth) {
                    this.choices.icon = tc === 'email' ? 'phone-fill' : 'envelope-fill'; 
                } else {
                    this.choices.icon = tc === 'email' ? 'envelope-fill' : 'phone-fill'; 
                }
            }
        },
        changeChoiceValue(chanId) {
            if (!this.choices.codeSent) {
                this.choices.notBothValue.id = chanId;
            }
        }
    },
    computed: {
        targetInfoText: function() {
            if (this.verifData.data.hasBoth) {
                return this.choices.mainChoice === 'email' ?
                this.langTextTpl('easyOnboarding.mfa.otp2msisdn', { masked_msisdn: this.verifData.data.mobilePhone }) :
                this.langTextTpl('easyOnboarding.mfa.otp2email', { masked_email: this.verifData.data.email });
            } else {
                return this.choices.mainChoice === 'email' ?
                this.langTextTpl('easyOnboarding.mfa.otp2email', { masked_email: this.choices.notBothValue.value }) :
                this.langTextTpl('easyOnboarding.mfa.otp2msisdn', { masked_msisdn: this.choices.notBothValue.value });                
            }
        },
        targetLabelText: function() {
            if (this.verifData.data.hasBoth) {
                return this.choices.mainChoice === 'email' ? ' z SMS správy' : ' z e-mailu';
            } else {
                return this.choices.mainChoice === 'email' ? ' z e-mailu' : ' z SMS správy';
            }
        },
        noBothHasChannel: function() {
            return (this.verifData.data.channels?.msisdn).length > 0 || (this.verifData.data.channels?.email).length > 0;
        }
    },
    watch: {
        "choices.notBothValue.id": function (newVal) {
            const c = newVal.split('_')[0];
            this.choices.notBothValue.channel = c;
            this.choices.notBothValue.value = _.filter(this.verifData.data.channels[c], function(v) { return v.id === newVal})[0]?.value;            
            this.changeChoice(c);
        },
        "choices.codeSent": function() {
            this.choices.error = false;
            this.choices.errorText = this.langText('easyOnboarding.mfa.otpError', true);
        }     
    }
}
</script>
<style scoped>
</style>
